import { Utils } from "@/plugins/utils";

export default {
	namespaced: true,
	state: {
		showZoom: false,
		dc0Zoom: null,
		lstDc1Zoom: null,
		lstDc0: null,
		lstDc1: null
	},
	getters: {
		getLstDc1: state => state.lstDc1,
	},
	mutations: {
		
	},
	actions: {
		async searchField(store, { field, text, moreFilters, conditions }){
			let queryMoreFilters = ""
			let queryEspecificConditions = ""
			moreFilters.forEach(moreFilter => {
				queryMoreFilters += `&moreFilters=${moreFilter}` 
			});
			conditions.forEach(condition => {
				queryEspecificConditions += `&conditions=${condition}` 
			});
			return await this._vm.$axios.get(`/Search/Field/Search?field=${field}&text=${text}${queryMoreFilters}${queryEspecificConditions}`)
			.then(response => {
				return Utils.ValidateAxiosResponse(response.data);
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return []
			});
		},
		async findTable(store, { field, text, moreFilters, orderBy = "" }){
			let queryMoreFilters = ""
			moreFilters.forEach(moreFilter => {
				queryMoreFilters += `&moreFilters=${moreFilter}` 
			});
			return await this._vm.$axios.get(`/Search/Field/FindTable?field=${field}&text=${text}&orderBy=${orderBy}${queryMoreFilters}`)
			.then(response => {
				let newList = []
				let list = Utils.ValidateAxiosResponse(response.data)
				for (const item of list) {
					let newItem = Utils.ToLowerKeys(item);
					newList.push(newItem)
				}
				return newList
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return []
			});
		},
		openZoom(store, zoom){
		},
		async getMultipleDc0(store, lstDc0arquivo){
			if (!lstDc0arquivo){
				store.state.lstDc0 = null
				return false
			}

			let lstDc0 = await store.dispatch("dictionary/getMultipleDc0", lstDc0arquivo, { root:true })
			store.state.lstDc0 = lstDc0
			return true
		},
		async getMultipleDc1(store, lstDc1arquivo){
			if (!lstDc1arquivo){
				store.state.lstDc1 = null
				return false
			}

			let lstDc1 = await store.dispatch("dictionary/getMultipleDc1", lstDc1arquivo, { root:true })
			store.state.lstDc1 = lstDc1
			return true
		},
	}
}